import api from "./api";
import { OrderSummary, OrderDetail } from "../pages/OrderViewer/types";

export async function searchOrdersByPhone(
  storeId: string | undefined,
  phone: string,
): Promise<OrderSummary[]> {
  const resp = await api().get(
    `/orders?storeId=${storeId}&phone=${encodeURIComponent(phone)}&limit=10`,
  );
  if (resp.status !== 200) {
    throw new Error("Falha ao buscar pedidos");
  }
  const json = resp.data;
  return json.data ?? json;
}

export async function getOrderDetail(orderId: string): Promise<OrderDetail> {
  const resp = await api().get(`/sale/${orderId}`);
  if (resp.status !== 200) {
    throw new Error("Falha ao buscar detalhes do pedido");
  }
  const json = resp.data;
  return json.data ?? json;
}
